import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DoctorsNextService } from 'src/app/feature/doctors-next.service';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { DoctorsNextRegisterStateService } from '../doctors-next-register-state.service';

@Component({
  selector: 'app-doctors-next-register-confirm',
  templateUrl: './doctors-next-register-confirm.component.html',
  styleUrls: [
    './doctors-next-register-confirm.component.css',
    '../style/index.css',
    '../style/registration.css',
  ],
})
export class DoctorsNextRegisterConfirmComponent implements OnInit {
  @Input()
  clientId!: string;

  rows: {
    label: string;
    value: string;
  }[] = [];

  @Input()
  errorMessages?: {
    signup: {
      givenName: '';
      familyName: '';
      email: '';
      password: '';
      confirmPassword: '';
      gender: '';
      birthDate: '';
      terms: '';
      privacyPolicy: '';
    };
  };

  @Output()
  finish = new EventEmitter();

  constructor(
    private registerStateService: DoctorsNextRegisterStateService,
    private next: DoctorsNextService,
    private auth0: Auth0Service
  ) {}

  ngOnInit(): void {
    const { selected, base } = this.registerStateService;
    if (!base) throw new Error('base is required');
    const { year, month, date } = base.birthdate;

    const roles = this.registerStateService.roles.concat([
      {
        key: 'others',
        label: 'その他医療従事者',
      },
    ]);
    this.rows = [
      { label: '生年月日', value: `${year}年${month}月${date}日` },
      { label: 'メールアドレス', value: base?.email },
      {
        label: '職種',
        value: roles.find((r) => r.key === selected.role)?.label || '',
      },
    ];

    // その他医療従事者の場合の詳細記載
    if (selected.role === 'others') {
      this.rows.push({
        label: 'その他医療従事者(詳細)',
        value: selected.othersDescription || '',
      });
    }
    if (selected.role === 'doctor') {
      this.rows.push({
        label: '医師免許資格取得年',
        value: selected.licenseAcquisitionYear + '年' || '',
      });
    }
    if (selected.departments.length > 0) {
      this.rows.push({
        label: this.registerStateService.departmentLabel,
        value: selected.departments.join('、'),
      });
    }
    this.rows.push(
      ...[
        { label: 'お勤め先の職種', value: selected.industryType || '' },
        {
          label: '所属医療機関名 / 勤務先名',
          value: selected.affiliation || '',
        },
        {
          label: '勤務地',
          value: [selected.pref, selected.address, selected.building].join(' '),
        },
        { label: '役職', value: selected.position || '' },
      ]
    );
  }

  async apply() {
    this.finish.emit();
  }

  cancel() {
    this.registerStateService.inputStep = 'speciality';
  }

  get isRegistarble() {
    const errorLength = Object.keys(this.errorMessages?.signup || {}).length;
    if (errorLength > 0) return false;
    return true;
  }
}
